import { render, staticRenderFns } from "./TermsOfUseCheckbox.vue?vue&type=template&id=7584c3bc&scoped=true"
import script from "./TermsOfUseCheckbox.vue?vue&type=script&lang=js"
export * from "./TermsOfUseCheckbox.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseCheckbox.vue?vue&type=style&index=0&id=7584c3bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7584c3bc",
  null
  
)

export default component.exports